// ADDENDUM 45 — «Requiere atención»: qué hace que una operación pida ser mirada.
//
// ⚠️⚠️ ESTO NO INVENTA NINGUNA ALERTA NUEVA. Los dos motivos ya se pintaban en el desplegable, cada
// uno por su lado y en sitios distintos: el margen sin reportar como una píldora junto al estado, y
// el exceso sobre el teórico como una cifra dentro de los tiempos. Lo único que cambia es que se
// LEEN JUNTOS y arriba, que es lo que el mockup del PO pide. Reusar las mismas reglas —y no
// escribir otras parecidas aquí— es lo que impide que el aviso y la píldora acaben discrepando.
//
// 📌 DEVUELVE MOTIVOS, NO FRASES. Cada motivo es una clave y sus datos; la traducción la pone
// quien pinta, que es quien tiene el `t_`. Es el mismo contrato que `operationStatus` o
// `deviationLabel`: aquí no entra texto de pantalla.
import { hasUnreportedSlack } from './operationRowFlags'
import { timeVsTheoretical } from './timeVsTheoretical'
import { isBlank } from './detailShared'

/**
 * @param {object} row la fila de N3
 * @param {string} [since] el arranque más temprano de cualquier operario, si se conoce
 * @returns {Array<{key: string, since?: string, deltaSeconds?: number}>} en orden de lectura, vacío
 *   si no hay nada que avisar — y VACÍO ES LA RESPUESTA NORMAL: si el aviso saliera en todas las
 *   filas dejaría de avisar de nada, que es la lección del rojo permanente de las rechazadas.
 */
export const attentionReasons = (row, since) => {
  const source = row || {}
  const reasons = []

  // Mismo predicado que la píldora «Sin reportar» de la lista, importado y no reescrito.
  if (hasUnreportedSlack(source)) {
    // ⚠️ `since` es OPCIONAL de verdad: sale del arranque más temprano de los operarios y puede no
    // haber ninguno. El motivo se da igual sin fecha — que falte el cuándo no hace que el hecho
    // deje de ocurrir, y quien pinta elige el literal con fecha o sin ella (RN8).
    reasons.push(isBlank(since) ? { key: 'unreported-slack' } : { key: 'unreported-slack', since })
  }

  const { computable, over, deltaSeconds } = timeVsTheoretical(source.theoreticalDurationSeconds, source.actualDurationSeconds)
  if (computable && over) {
    reasons.push({ key: 'over-theoretical', deltaSeconds })
  }

  return reasons
}
